<template>
  <div id="customers" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col lg:w-1/2 w-full">
            <div
              class="dropdown-button-container"
              v-has-permission="permission88"
            >
              <vs-dropdown :vs-trigger-click="true">
                <vs-button
                  class="btn-drop vs-component vs-button bg_l_green"
                  color="success"
                  icon="add"
                  :vs-trigger-click="true"
                  >{{ $t("CreateCustomer") }}</vs-button
                >
                <vs-dropdown-menu id="customer-dp">
                  <vs-dropdown-item>
                    <router-link :to="{ path: '/Customers/CreateIndividual' }">
                      {{ $t("Individual") }}
                    </router-link>
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                    <router-link :to="{ path: '/Customers/CreateLegal' }">
                      {{ $t("Legal") }}
                    </router-link>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
          <div class="vx-col w-full gap-4 flex flex-wrap justify-end">
            <div class="flex">
              <label class="custom-file-upload flex">
                <input
                  type="file"
                  id="file"
                  ref="legalFileElement"
                  v-on:change="handleLegalFileSelection()"
                />
                <div class="flex gap-2 items-start">
                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />{{ $t("CreateLegalCustomerWithExcel") }}
                </div>
                <span v-if="selectedLegalFileName" class="file-name">{{
                  selectedLegalFileName
                }}</span>
              </label>
              <vs-button
                @click="uploadLegalCustomersFile()"
                class="bg_m_green float-right"
                v-if="legalFileSelected"
                :disabled="legalUploadButtonDisabled"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Submit") }}
              </vs-button>
            </div>
            <div class="flex">
              <label class="custom-file-upload flex">
                <input
                  type="file"
                  id="file"
                  ref="individualFileElement"
                  v-on:change="handleIndividualFileSelection()"
                />
                <div class="flex gap-2 items-start">
                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  <span>{{ $t("CreateIndividualCustomerWithExcel") }}</span>
                </div>
                <span v-if="selectedIndividualFileName" class="file-name">{{
                  selectedIndividualFileName
                }}</span>
              </label>
              <vs-button
                @click="uploadIndividualCustomersFile()"
                class="bg_m_green float-right"
                v-if="individualFileSelected"
                :disabled="individualUploadButtonDisabled"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Submit") }}
              </vs-button>
            </div>
            <filter-button @click="toggleShowFilters" />
          </div>
        </div>
        <form v-if="showFilters" class="filter-form">
          <div class="vx-row mb-6">
            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
              <label class="vs-select--label mb-1">{{
                $t("CustomerType")
              }}</label>
              <v-select
                label="name"
                :options="customers"
                v-model="gridSearchData.customerTypeQuery"
                :reduce="(x) => x.id"
                :clearable="false"
                ref="customerType"
                dir="rtl"
              >
              </v-select>
            </div>
            <div
              class="vx-col lg:w-2/3 sm:w-1/2 w-full mt-6 flex gap-4 justify-end"
            >
              <vs-button
                type="filled"
                color="#3ec9d6"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
              <vs-button
                type="filled"
                class="float-right"
                @click.prevent="submitFilter()"
                >{{ $t("SubmitFilter") }}</vs-button
              >
            </div>
          </div>
        </form>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                {
                  title: $t('SocialSecurityNumber'),
                  sort: 'SocialSecurityNumber',
                },
                { title: $t('CompanyNationalId'), sort: 'CompanyNationalId' },
                { title: $t('EconomicCode'), sort: 'EconomicCode' },
                { title: $t('PartyType'), sort: 'PartyType' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 26%">
                  {{ row.name }}
                </td>
                <td style="width: 15%">
                  <span v-if="row.socialSecurityNumber">
                    {{ row.socialSecurityNumber }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td style="width: 15%">
                  <span v-if="row.companyNationalId">
                    {{ row.companyNationalId }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td style="width: 15%; direction: ltr">
                  <span v-if="row.economicCode">{{ row.economicCode }}</span>
                  <span v-else>-</span>
                </td>
                <td style="width: 15%; direction: ltr">
                  <span v-if="row.partyType == 'Individual'">
                    {{ $t("Individual") }}
                  </span>
                  <span v-if="row.partyType == 'Legal'">
                    {{ $t("Legal") }}
                  </span>
                </td>
                <td style="width: 10%; direction: ltr">
                  <span v-if="row.partyType == 'Individual'">
                    <router-link
                      :to="{ path: '/Customers/EditIndividual/' + row.id }"
                    >
                      <vs-button
                        radius
                        color="success"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="d-inline"
                      ></vs-button>
                    </router-link>
                  </span>
                  <span v-else-if="row.partyType == 'Legal'">
                    <router-link
                      :to="{ path: '/Customers/EditLegal/' + row.id }"
                    >
                      <vs-button
                        radius
                        color="success"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="d-inline"
                      ></vs-button>
                    </router-link>
                  </span>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
</style>
<style lang="scss">
.bg_l_green {
  cursor: pointer;
}

.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}

.filter-form {
  border-top: 1px dashed #ddd;
  padding-top: 0.5rem;
}

.filter-form
  .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  padding: 0.5rem 2rem;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import FilterButton from "@/components/buttons/FilterButton.vue";

export default {
  data() {
    return {
      permission88: "CreateIndividualCustomer|CreateCustumerLegal",
      gridDataSource: {
        type: "app",
        service: "BusinessParties/api/CustomersQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      showFilters: false,
      customers: [
        { name: "حقیقی", id: 1 },
        { name: "حقوقی", id: 2 },
      ],
      legalFileElement: null,
      individualFileElement: null,
      legalFileSelected: false,
      legalUploadButtonDisabled: false,
      selectedLegalFileName: "",
      individualFileSelected: false,
      individualUploadButtonDisabled: false,
      selectedIndividualFileName: "",
    };
  },
  methods: {
    ...mapActions({
      importIndividualCustomers: "excel/importIndividualCustomers",
      importLegalCustomers: "excel/importLegalCustomers",
    }),
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.gridSearchData = {
        keyword: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid();
        this.$refs.customerType.clearSelection();
      }, 0);
    },
    handleLegalFileSelection() {
      this.legalFileElement = this.$refs.legalFileElement.files[0];
      this.selectedLegalFileName = this.legalFileElement.name;
      this.legalFileSelected = true;
    },
    handleIndividualFileSelection() {
      this.individualFileElement = this.$refs.individualFileElement.files[0];
      this.selectedIndividualFileName = this.individualFileElement.name;
      this.individualFileSelected = true;
    },
    uploadLegalCustomersFile() {
      this.legalUploadButtonDisabled = true;
      let formData = new FormData();
      formData.append("file", this.legalFileElement);
      this.importLegalCustomers(formData)
        .then(() => {
          this.onFileUploadSuccess();
        })
        .finally(() => {
          this.legalUploadButtonDisabled = false;
        });
    },
    uploadIndividualCustomersFile() {
      this.individualUploadButtonDisabled = true;
      let formData = new FormData();
      formData.append("file", this.individualFileElement);
      this.importIndividualCustomers(formData)
        .then(() => {
          this.onFileUploadSuccess();
        })
        .finally(() => {
          this.individualUploadButtonDisabled = false;
        });
    },
    onFileUploadSuccess() {
      this.$refs.legalFileElement.value = null;
      this.$refs.individualFileElement.value = null;
      this.legalFileSelected = false;
      this.individualFileSelected = false;
      this.selectedLegalFileName = "";
      this.selectedIndividualFileName = "";
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 1500);
    },
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    FilterButton,
  },
};
</script>
